const bubbleCircleSelector = '.bubbles-main circle';

function hasClosest(target: EventTarget): target is Element {
  return typeof (target as Element).closest === 'function';
}

/** True when a canvas click should drill up (outside interactive bubble nodes). */
export function shouldDrillUpFromCanvasClick(target: EventTarget | null): boolean {
  if (target == null || !hasClosest(target)) return true;
  if (target.closest(bubbleCircleSelector)) return false;
  return true;
}
